import * as React from 'react';
export const soundOffSvg = React.forwardRef(function soundOffSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.943 4.253 7.763.47c1.064-1.043 2.724-.213 2.724 1.184v12.694c0 1.397-1.66 2.227-2.724 1.184l-.003-.003-3.817-3.782h-.256C1.637 11.746 0 10.056 0 8s1.636-3.747 3.687-3.747h.256Zm1.051 1.068 3.818-3.783c.028-.026.046-.03.053-.031a.088.088 0 0 1 .05.008.12.12 0 0 1 .05.043c.01.016.024.045.024.095v12.694c0 .05-.013.079-.024.095a.12.12 0 0 1-.05.043.088.088 0 0 1-.05.008c-.007 0-.025-.005-.053-.031v-.001l-3.818-3.782V5.32ZM1.498 8c0-1.189.89-2.14 1.998-2.24v4.48C2.387 10.14 1.498 9.188 1.498 8Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.78 6.951a.75.75 0 0 0-1.059-1.06l-1.048 1.05-1.049-1.05a.749.749 0 1 0-1.059 1.06L12.614 8l-1.049 1.049a.75.75 0 0 0 1.06 1.06l1.048-1.05 1.048 1.05a.749.749 0 1 0 1.06-1.06l-1.049-1.05 1.049-1.048Z',
    }),
  );
});
soundOffSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var soundOff = {
  category: 'icon',
  colorable: true,
  name: 'soundOff',
  svg: soundOffSvg,
};
